'use client';

import { ProgressProvider } from '@bprogress/next/app';
import { PropsWithChildren, useEffect } from 'react';

export function Providers({ children }: PropsWithChildren) {
  useEffect(() => {
    try {
      sessionStorage.removeItem('global_error_retry_count');
    } catch {
      return;
    }
  }, []);

  return (
    <ProgressProvider
      height="4px"
      color="#ffcc00"
      shallowRouting
      options={{
        showSpinner: false
      }}
    >
      {children}
    </ProgressProvider>
  );
}
